var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',_vm._g(_vm._b({attrs:{"width":"auto","max-width":"80%"},on:{"close":_vm.close}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{class:_vm.$style.dialogImage,attrs:{"src":_vm.img_path},on:{"click":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }